import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import {bookLevelActions} from "../../store/bookLevel/bookLevelSlice";
import DeleteButton from "../../components/customTable/DeleteButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addBookLevelData, deleteBookLevelData, fetchBookLevelData, updateBookLevelData} from "../../store/bookLevel/bookLevelActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function BookLevels({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const bookLevels = useSelector(state => state.bookLevels.bookLevels)
    const isBookLevel = useSelector(state=>state.bookLevels.bookLevel)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [bookLevelId, setBookLevelId] = useState('')

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [bookLevel, setBookLevel] = useState({})

    const cols = [
        {
            name: "name",
            label: language.level_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <div>{value}</div>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setBookLevelId(bookLevels[tableMeta.rowIndex].id)
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setBookLevel(bookLevels[tableMeta.rowIndex])
                                    dispatch(bookLevelActions.getBookLevel(bookLevels[tableMeta.rowIndex]))
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setBookLevelId(bookLevels[tableMeta.rowIndex].id)
                                    console.log(bookLevelId)
                                    dispatch(bookLevelActions.getBookLevel(bookLevels[tableMeta.rowIndex]))
                                    setOpenDelete(true)
                                }
                                }
                            />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const saveBookLevel = () => {
        dispatch(bookLevelActions.getBookLevel(''))
        dispatch(addBookLevelData(bookLevel.name))
        setOpenAdd(false)
    }

    const deleteBookLevel = () => {
        dispatch(deleteBookLevelData(bookLevelId))
        setOpenDelete(false)
    }

    const editBookLevel = () => {
        dispatch(updateBookLevelData(bookLevelId, bookLevel.name))
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchBookLevelData())
    }, [dispatch,isBookLevel])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.bookLevels}
                        data={bookLevels}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deleteBookLevel}
                title={language.delete_book_level}
                warning={language.book_level_delete_warning}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={saveBookLevel}
                editItem={editBookLevel}
            >
                <DialogHeader
                    title={openEdit ? language.edit_book_level : language.add_book_level}
                    closeModal={() => setOpenAdd(false)}
                />
                <TextInput
                    label={language.level_name}
                    value={openEdit ? bookLevel.name : null}
                    onChange={(e) => setBookLevel({ ...bookLevel, name: e.target.value })}
                    placeholder={language.level_name}
                />
            </AddDialog>
        </div>
    );
}

export default BookLevels;